const { VITE_API_HOST } = import.meta.env;

/** Скільки показувати МТП на одній сторінці списку поселень  */
export const mtpItemPerPage = 15;

export const renderSettlementType = (category?: string) => {
    switch (category) {
        case 'CITY':
            return 'м. ';
            
        case 'URBAN_VILLAGE':
            return 'смт. ';
            
        case 'VILLAGE':
            return 'с. ';
            
        case 'SETTLEMENT':
            return 'селище ';
            
        default:
            break;
    }
};

export const isLocalhost = () => {
    const { hostname } = window.location;
    return (
        hostname === '10.0.3.49' ||
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        hostname === '[::1]' || // IPv6 localhost
        hostname.endsWith('.localhost')
    );
};

export const getImageFullSrc = (src?: string) => {
    if (!src) return undefined;

    if (src.startsWith('http://') || src.startsWith('https://')) {
        return src;
    }

    if (src.startsWith('/public/') || src.startsWith('/photos/')) {
        return src;
    }
    
    return isLocalhost() ? `${VITE_API_HOST}${src}` : `${window.location.origin}${src}`;
}